module.exports = __webpack_public_path__ + "images/c0d78935a6ff422ef230bec2648e2d21.jpg";